<template lang="pug">
div(class="d-flex flex-column flex-grow-1 min-h-0 tw-h-full fill-height overflow-hidden")
  //Head
  div(class=" tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pb-1 tw-text-left")
    v-row
      v-col
        span(class="tw-text-2xl text-secondary tw-font-bold") {{ $t('Common.settings') }}

  //Tabs
  div(class=" tw-flex tw-h-full tw-flex-row tw-flex-grow tw-p-4 tw-pb-0 tw-pl-2 tw-overflow-hidden")
    v-row(align-self="start" class=" tw-flex tw-flex-row tw-h-full tw-flex-grow tw-p-2 tw-pt-0 tw-pb-0 ")
      v-col(class=" tw-h-full  tw-flex tw-flex-col tw-flex-grow  tw-py-0")
        v-form(ref="form" v-model="valid" lazy-validation @keyup.native.enter="valid && submit($event)")
          v-tabs(vertical class="tw-h-full tw-py-0 tw-my-0")
            v-tab
              span {{ $t('Website.Common.general') }}

            //General
            v-tab-item(transition="fade-transition" reverse-transition="fade-transition" class="tw-h-full")
              v-container(fluid class="tw-px-6")
                v-row(align-self="start" class=" tw-flex tw-flex-row tw-h-full tw-flex-grow tw-p-2 tw-pt-0 tw-pb-0 ")
                  v-col(class=" tw-h-full  tw-flex tw-flex-col tw-flex-grow  tw-py-0")
                    v-form(ref="form" v-model="error" lazy-validation @keyup.native.enter="valid && submit($event)")
                      v-row(class="mt-2 mx-2")
                        v-col(cols="5")
                          v-row
                            v-col
                              v-text-field(
                                v-model="website.name"
                                :label="$t('Website.Common.siteName')"
                                color="blue darken-4"
                                outlined
                                hide-details
                              )
                          v-row(align="center")
                            v-col(cols="5")
                              v-row(dense)
                                v-col(align="right" cols="12")
                                  v-img(
                                    v-if="website.logo == 'null'"
                                    :src="require('@/assets/images/placeholder-image.jpg')"
                                    width="100%"
                                  )
                                  helper-img-file-preview(v-if="typeof website.logo == 'object'" :file="website.logo")
                                  v-img(v-else :src="path(website.logo)" max-width="200")
                            v-col
                              div
                                span {{ $t('Website.Common.siteLogo') }}
                              div
                                v-file-input(accept="image/*" v-model="website.logo" hide-details)
                          v-row(class="mt-4")
                            v-col(align="right" cols="5")
                              v-img(
                                v-if="website.favicon == 'null'"
                                :src="require('@/assets/images/placeholder-image.jpg')"
                                width="50%"
                                height="100%"
                              )
                              helper-img-file-preview(
                                v-if="typeof website.favicon == 'object'"
                                :file="website.favicon"
                              )
                              v-img(v-else :src="path(website.favicon)" max-width="120")
                            v-col
                              div
                                span {{ $t('Website.Common.favicon') }}
                              div
                                v-file-input(accept="image/*" v-model="website.favicon" hide-details)

                        v-col(cols="7")
                          v-row(no-gutters class="tw-mb-0 tw-pb-0")
                            v-col
                              div
                                span {{ $t('Common.online') }}
                              div
                                p(class="mt-2 mb-0")
                                  span {{ $t('Website.Common.onlineDescription') }}
                            v-col(cols="auto")
                              div
                                v-switch(
                                  v-model="website.online"
                                  :true-value=1
                                  :false-value=0
                                  inset
                                  ripple=false
                                )

                          v-row(no-gutters)
                            v-col
                              div
                                span {{ $t('Website.Common.defaultURL') }}
                              div(class="tw-bg-blueGray-lighten-5 tw-rounded tw-py-4 tw-px-2 tw-mt-2")
                                v-row(dense align="center" justify="space-between")
                                  v-col(cols="auto")
                                    span http://{{ website.sub_domain }}.realtor.kubiqa.com
                                  v-col(cols="auto")
                                    a(
                                      :href="'http://' + website.sub_domain + '.realtor.kubiqa.com'"
                                      target="_blank"
                                      :title="$t('Website.Common.preview')"
                                    )
                                      v-icon(small) mdi-open-in-new

                          v-row
                            v-col
                              div(class="pb-2")
                                span {{ $t('Website.Common.setupDomainLabel') }}
                              div
                                v-text-field(
                                  v-model="website.domain"
                                  :label="$t('Website.Common.customURL')"
                                  color="blue darken-4"
                                  outlined
                                  hide-details
                                )
                          v-row
                            v-col
                              div(class="pb-1")
                                div(class="inline-block")
                                  span {{ $t('Website.Common.verifyDomainLabel') }}
                                  v-tooltip(
                                    bottom
                                    nudge-right="40"
                                    color="black"
                                    allow-overflow
                                    class=" tw-mx-4"
                                    min-width="320"
                                  )
                                    template(v-slot:activator="{ on, attrs }")
                                      span(v-bind="attrs" v-on="on")
                                        v-icon(small class="tw-pl-1") mdi-help-circle-outline
                                    div
                                      p(class="text-left  tw-text-white") {{ $t('Website.Common.verifyDomainHelp') }}

                              v-row(dense align="center" class=" tw--mt-2")
                                v-col
                                  div(class="tw-bg-blueGray-lighten-5 tw-rounded tw-py-4 tw-px-2 tw-mt-2")
                                    v-row(no-gutters align="center")
                                      v-col
                                        span kubiqa-domain-verification={{ website.dns_txt }}
                                      v-col(cols="auto")
                                        v-icon(small @click="copy") mdi-content-copy
                              v-row(dense justify="end")
                                v-col(cols="auto")
                                  v-btn(
                                    @click="dnsValidate"
                                    outlined
                                    text
                                    :color="dnsCheckColor"
                                    height="48"
                                    :loading="dnsCheckLoading"
                                    :disabled="website.domain_verified"
                                  )
                                    v-icon(v-if="dnsCheckColor === 'green'" small color="green") mdi-check
                                    span(v-if="dnsCheckColor === 'green'") {{ $t('Common.verified') }}
                                    span(v-else) {{ $t('Common.verify') }}

  //Foot
  div(class="tw-flex tw-flex-row tw-flex-grow-0 tw-p-4 tw-pt-1 ")
    v-row(justify="end" align-self="end" align="end" class="tw-bottom-0")
      v-col(cols="auto" align-end class="tw-h-full fill-height")
        v-btn(@click="cancel" text :ripple="false")
          span(class=" tw-text-kPurple tw-mt-4") {{ $t('Common.cancel') }}
        v-btn(depressed color="rgba(94,129,244,0.80)" :loading="loading" @click="submit")
          span(class="tw-font-bold") {{ $t('Common.save') }}
</template>
<script>
export default {
  data() {
    return {
      website: {},
      loading: false,
      error: false,
      selectedSocialNetwork: '',
      dnsCheckLoading: false,
      current_domain: '',
      socialNetworks: [
        {
          id: 1,
          name: 'Facebook',
          icon: 'mdi-facebook',
        },
        {
          id: 2,
          name: 'Twitter',
          icon: 'mdi-twitter',
        },
        {
          id: 3,
          name: 'LinkedIn',
          icon: 'mdi-linkedin',
        },
        {
          id: 4,
          name: 'Instagram',
          icon: 'mdi-instagram',
        },
        {
          id: 5,
          name: 'YouTube',
          icon: 'mdi-youtube',
        },
        {
          id: 6,
          name: 'Pinterest',
          icon: 'mdi-pinterest',
        },
        {
          id: 7,
          name: 'TikTok',
          icon: 'mdi-tiktok',
        },
        {
          id: 8,
          name: 'WhatsApp',
          icon: 'mdi-whatsapp',
        },
      ],
    };
  },
  mounted() {
    this.website = JSON.parse(JSON.stringify(this.$store.getters['website/website']));
    if (this.website.domain == 'null') {
      this.website.domain = '';
    } else {
      this.current_domain = this.website.domain;
      this.domain_verified = this.website.domain_verified;
    }
  },
  computed: {
    dnsCheckColor: {
      get() {
        if (this.website.domain_verified) {
          return 'green';
        } else {
          return 'grey';
        }
      },
      set(value) {
        this.website.domain_verified = value;
      },
    },
  },
  watch: {
    'website.domain'(newValue, oldValue) {
      if (newValue != this.current_domain) {
        this.website.domain_verified = false;
      }
    },
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.error = true;
        this.error_message = 'error';
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store
          .dispatch('website/update', this.website)
          .then((response) => {
            this.$emit('close');
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            console.log(error);
          });
      }
    },
    copy() {
      navigator.clipboard.writeText('kubiqa-dv=' + this.website.dns_txt);
    },
    dnsValidate() {
      this.dnsCheckLoading = true;
      this.$store
        .dispatch('website/dnsValidate', this.website.domain)
        .then(() => {
          this.dnsCheckLoading = false;
          this.dnsCheckColor = true;
        })
        .catch((error) => {
          this.dnsCheckColor = false;
          commit('SET_ERROR', error, { root: true });
        });
    },
  },
};
</script>
